export default __webpack_public_path__ + "static/media/raman6.312370d1.png";